import { Route } from 'react-router-dom'

// Layout
import SystemAdminLayout from '../layout/SystemAdminLayout'

// Pages
import AdminDashboardPage from '../pages/admin/AdminDashboardPage'

// Guards
import ProtectedRoute from '../core/guards/ProtectedRoute'
import { AppRoute } from '../core/config/app-routes'
import SettingsPage from '@/pages/business/SettingsPage'

export default function SystemAdminRoutes() {
    return (
        <>
            <Route
                path={AppRoute.SYSTEM_ADMIN_DASHBOARD_ROUTE}
                element={
                    <ProtectedRoute>
                        <SystemAdminLayout>
                            <AdminDashboardPage />
                        </SystemAdminLayout>
                    </ProtectedRoute>
                }
            />

            {/* Settings */}
            <Route
                path={AppRoute.SYSTEM_ADMIN_SETTINGS_ROUTE}
                element={
                    <ProtectedRoute>
                        <SystemAdminLayout>
                            <SettingsPage />
                        </SystemAdminLayout>
                    </ProtectedRoute>
                }
            />
        </>
    )
}


